import * as React from "react";
import { useFormContext } from "react-hook-form";
import { AutoComplete } from "components";
import { SURGEON_ROLES } from "duck";
import { FormValues } from "../../duck";

const Doctors: React.FC = () => {
  const { watch } = useFormContext<FormValues>();
  const enabled = watch("evaluateTestAndTreat");

  return (
    <AutoComplete.Users
      label="Doctor"
      labelHidden
      isDisabled={!enabled}
      role={SURGEON_ROLES}
      name="doctor"
      placeholder="Select a doctor"
    />
  );
};

export default Doctors;
